module.exports = __webpack_public_path__ + "assets/img/business.1462d66f.png";